import { Box, Text, xcss } from "@atlaskit/primitives";
import React from "react";

function StyledText({
  color = "color.text",
  size = "medium",
  align = "center",
  customStyles = {},
  maxLines,
  children,
}) {
  return (
    <Box
      xcss={xcss({
        "span:first-child": {
          ...customStyles,
        },
        textAlign: align,
      })}
    >
      <Text
        color={color}
        align={align}
        size={size}
        style={customStyles}
        maxLines={maxLines}
      >
        {children}
      </Text>
    </Box>
  );
}

export default StyledText;
